import { NAVIGATION_SERVICE_CDN_URL } from '../constants/config'
import type { NavigationData } from '../types/navigation'

/**
 * Fetches pre-computed navigation data for a specific user variation.
 * Browser-safe — no Node.js dependencies (no node-cache, no ubik-logging).
 * Intended for client-side hydration where the variation key is already known.
 */
export const fetchNavigationByVariation = async (locale: string, userVariationKey: string, tenant: string): Promise<NavigationData> => {
  const encodedKey = encodeURIComponent(userVariationKey)
  const url = `${NAVIGATION_SERVICE_CDN_URL}/${tenant}/${locale}/${encodedKey}`

  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`Failed to fetch navigation data by variation: ${response.statusText}`)
  }

  return response.json()
}
